import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	settings: {
		paddingTop: 15,
	},
	settingsContainer: {},
});
